<template>
  <div>

    <div class="h-panel">
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="gifts !== null && gifts.length > 0" class="table table-bordered text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col" rowspan="2">Id</th>
          <th scope="col" rowspan="2">Time</th>
          <th scope="col" colspan="2">Sender</th>
          <th scope="col" rowspan="2">From friend</th>
          <th scope="col" rowspan="2">Type</th>
          <th scope="col" colspan="2">Product</th>
          <th scope="col" rowspan="2">Claimed</th>
        </tr>
        <tr>
          <th scope="col">id</th>   <!-- sender id -->
          <th scope="col">name</th> <!-- sender name -->

          <th scope="col">proto</th>  <!-- product proto -->
          <th scope="col">amount</th> <!-- product amount -->
        </tr>
      </thead>
      <tr
        v-for="gift in gifts"
        :key="gift.id"
      >
        <td>
          {{gift.id}}
        </td>
        <td>
          {{gift.ctime | getMomentStr}}
        </td>
        <td>
          <player-link :playerId="gift.sender_id" lable="player"/>
        </td>
        <td>
          {{gift.sender_name}}
        </td>
        <td>
          {{gift.from_friend | numberToBoolStr}}
        </td>
        <td>
          {{gift.gift_type | getGiftTypeName}}
        </td>
        <td>
          {{gift.item_proto_id | getProtoStr}}
        </td>
        <td>
          {{gift.items_count}}
        </td>
        <td>
          {{gift.claimed | numberToBoolStr}}
        </td>
      </tr>
    </table>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показаны подарки,
          которые другие игроки (отправители) отправили данному игроку.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { getEnumClubGiftTypeName } from '../autogen/bundle.js';

import LoadingIndicator from './LoadingIndicator.vue';
import PlayerLink from './PlayerLink.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerClubGifts',

  components: {
    LoadingIndicator,
    PlayerLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      /** @type {?DataClubGift[]} */
      gifts: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {?string} */
    message() {
      if(this.gifts !== null && this.gifts.length === 0) {
        return 'No gifts from other players.';
      }
      return null;
    },
  },

  created() {
    this.loadGifts();
  },

  methods: {
    loadGifts() {
      notifier.deleteSenderNotifications(this);
      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/club_gifts`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.gifts = data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    getGiftTypeName,
  },
};


/**
 * @typedef {Object} DataClubGift
 * @property {number} id
 * @property {number} player_id
 * @property {number} sender_id
 * @property {number} ctime
 * @property {number} claimed
 * @property {number} from_friend
 * @property {string} sender_name
 * @property {number} gift_type (EnumClubGiftType)
 * @property {number} item_proto_id
 * @property {number} items_count
 */


/**
 * @param {number} typeCode
 * @returns {string}
 */
function getGiftTypeName(typeCode) {
  switch(typeCode) {
    case 0: return 'life';
    case 1: return 'golden card reward';
  }
  return getEnumClubGiftTypeName(typeCode);
}
</script>
